module.exports = __webpack_public_path__ + "img/7364166b363d0645996yy6da07fbe8fb.9f329d47.png";